export default __webpack_public_path__ + "static/media/bg-login.4cd048c6.png";